import { useState } from "react";

import { ButtonV4, FieldV4, ModalV4 } from "../common/ui";

import type { Receipt } from "./billingHistoryModelV4";

// Types
type ModalBillingReceiptCopyV4Props = {
  // data
  receipt: Receipt;
  busy?: boolean;
  // callback
  onConfirm: (note: string) => void;
  onClose: () => void;
};

/** เหตุผลการพิมพ์สำเนาใบเสร็จ */
const ModalBillingReceiptCopyV4 = (props: ModalBillingReceiptCopyV4Props) => {
  const [note, setNote] = useState("");

  // Handler
  const handleConfirm = () => {
    props.onConfirm(note.trim());
  };

  // Render
  return (
    <ModalV4 title="พิมพ์สำเนาใบเสร็จ" width={520} onClose={props.onClose}>
      <div className="hv4-bill-hist-modal">
        <div className="hv4-bill-hist-modal-sub">
          {props.receipt.code} · Encounter {props.receipt.encounter_no}
        </div>
        <FieldV4 label="ระบุเหตุผลการพิมพ์สำเนาใบเสร็จ *" htmlFor="hv4_bill_copy_note">
          <input
            id="hv4_bill_copy_note"
            className="hv4-input"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </FieldV4>
        <div className="hv4-bill-hist-modal-foot">
          <ButtonV4 variant="ghost" onClick={props.onClose}>
            ปิด
          </ButtonV4>
          <ButtonV4 variant="primary" disabled={props.busy || !note.trim()} onClick={handleConfirm}>
            พิมพ์สำเนาใบเสร็จ
          </ButtonV4>
        </div>
      </div>
    </ModalV4>
  );
};

ModalBillingReceiptCopyV4.displayName = "ModalBillingReceiptCopyV4";

export default ModalBillingReceiptCopyV4;
